<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="4"
        v-for="field in params.fields"
        :key="field.name"
        :class="field.name"
      >
        <v-text-field
          v-if="field.type == 'varchar'"
          v-model="fieldValues[field.name]"
          :label="field.label"
          required
          outlined
          rounded
          dense
        />
        <v-select
          v-if="field.type === 'references'"
          :items="referencesData"
          item-text="transName"
          v-model="fieldValues[field.name]"
          required
          outlined
          rounded
          dense
          return-object
          :multiple="field.multiple ? field.multiple : false"
        />
        <template v-if="field.type === 'password'">
          <div
            :class="{
              invalid:
                ($v.fieldValues.password.$dirty && !$v.fieldValues.password.required) ||
                ($v.fieldValues.password.$dirty && !$v.fieldValues.password.minLength)
            }"
          >
            <v-text-field
              v-model.trim="fieldValues[field.name]"
              :label="$t('Новый пароль')"
              type="password"
              required
              outlined
              rounded
              dense
            />
            <p v-if="$v.fieldValues.password.$dirty && !$v.fieldValues.password.minLength">
              <small
                class="helper-text invalid"
              >
                {{ $t("Пароль должен содержать не менее") }}
                {{ $v.fieldValues.password.$params.minLength.min }} {{ $t("символов") }}.
              </small>
            </p>
          </div>
          <div
            :class="{
              invalid:
                ($v.fieldValues.password.$dirty && !$v.fieldValues.password.required) ||
                ($v.fieldValues.repeatPassword.$dirty && fieldValues.repeatPassword !== fieldValues.password)
            }"
          >
            <v-text-field
              v-model.trim="fieldValues.repeatPassword"
              :label="$t('Повторите пароль')"
              type="password"
              required
              outlined
              rounded
              dense
            />
            <small
              v-if="$v.fieldValues.repeatPassword.$dirty && fieldValues.password !== fieldValues.repeatPassword"
              class="helper-text invalid"
            >
              {{ $t("Пароль должен совпадать. Попробуйте еще") }}
            </small>
          </div>
        </template>
        <template v-if="field.type === 'date'">
          <v-menu
            v-model="dateMenu[field.name]"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fieldValues[field.name]"
                :label="field.label"
                required
                readonly
                v-on="on"
                outlined
                rounded
                dense
              />
            </template>
            <v-date-picker
              v-model="fieldValues[field.name]"
              @input="adoptionDateMenu = false"
              :weekday-format="getDay"
              :month-format="getMonthFormat"
              :header-date-format="getHeaderDateFormat"
              no-title
              first-day-of-week="1"
            />
          </v-menu>
        </template>
      </v-col>
      <v-col cols="12" md="12">
        <v-btn @click="save" small outlined color="primary">
          {{ $t('Сохранить') }}
        </v-btn>
        <v-btn @click="cancel" class="ml-2" small outlined>
          {{ $t('Отмена') }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { required, minLength, sameAs } from 'vuelidate/lib/validators'
  import User from '@/model/user'
  import mixin from '@/plugins/mixin/mixin'

  export default {
    mixins: [mixin],
    props: {
      params: Object
    },
    data: () => ({
      load: false,
      fieldValues: {},
      referencesData: [],
      baseUrl: process.env.VUE_APP_BACK_URL,
      dateMenu: {}
    }),
    validations: {
      fieldValues: {
        password: { required, minLength: minLength(8) },
        repeatPassword: {
          sameAsPassword: sameAs('password')
        }
      }
    },
    mounted() {
      let self = this

      this.params.fields.forEach(function (field) {
        self.$set(self.fieldValues, field.name, field.value)

        if (field.type === 'date') {
          self.$set(self.dateMenu, field.name, false)
        }
      })

      if (this.params.model) {
        User.getReferencesData(this.params.model).then((response) => {
          this.referencesData = response.data
        })
      }
    },
    methods: {
      save() {
        const field = this.params.fields[0]
        if (field.type === 'password' && !this.validateForm()) {
          return
        }
        User.update(this.fieldValues, this.params.userId ? this.params.userId : null).then((response) => {
          this.$emit('update-field', {
            status: true,
            fieldName: this.params.name,
            user: response.data
          })
        })
      },
      cancel() {
        this.$emit('update-field', {
          status: true,
          fieldName: this.params.name
        })
      },
      // Валидация формы
      validateForm() {
        this.$v.$touch()

        if (this.$v.$invalid) {

          this.$nextTick(() => {
            this.scrollToFirstError()
          })

          return false
        }
        return true
      },
      // Прокручивание до поля с ошибкой
      scrollToFirstError() {
        const domRect = document.querySelector('.invalid').getBoundingClientRect()
        window.scrollTo(
          domRect.left +
          (document.body.scrollLeft || document.documentElement.scrollLeft),
          domRect.top +
          (document.body.scrollTop || document.documentElement.scrollTop) -
          90
        )
      }
    }
  }
</script>
